import React from 'react';

import { DescriptionLoader, TitleBlocLoader } from 'modules/shared-cms-advanced';
import { ActualiteLoader } from 'modules/shared-cms-advanced/enhanced-blocs/actualite/actualite-component-loader';

import styles from './home-alt-page.module.css';

export const HomeAltLoader: React.FC = React.memo(() => {
    return (
        <div className={styles.rootContainer}>
            <TitleBlocLoader size="large" largeLegend />
            <div className={styles.description1} style={{ width: '100%' }}>
                <DescriptionLoader fullwidth />
            </div>
            <ActualiteLoader />
        </div>
    );
});
